export default {
  get_volunteer_by_location: {},
  searchTerm: "",
  get_location: "",
  get_volbyid: {},
  get_allreviewbyid: {},
  user_volbooking: {},
  get_allbookingvol: {},
  add_review: {},
  get_volunteerbyuserId: {},
  get_volunteerbooking: {},
  get_completedbooking: {},
  get_upcomingbooking: {},
  getall_requirement: {},
  get_volunteer_by_admin: {},
  get_all_count: {},
  get_allbookingcounts: {},
  get_location_by_name: {},
  get_all_location: {},
  add_location: {},
  edit_location: {},
  delete_location: {},
  get_all_location_name: [],
  getVolunteerByService: {},
  getVolunteerByDesignation: {},
  serviceDiscount: {},
  withdrawalRequest: {},
  allWithdrawalRequest: {},
};
